"use strict";const t=require("../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js");t.__require();
//# sourceMappingURL=hoist-non-react-statics.cjs.js.map
